import { useQuery } from '@tanstack/react-query'
import { useContext } from 'react'
import { authContext } from '../../context/auth-context'
import { useParams } from 'react-router-dom'

const initiateTemp = async ({ token, id }: { token: string; id: string }) => {
  const response = await fetch(`${process.env.REACT_APP_API_HOST}/api/groups/user-group/${id}/initiate-update/`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.json()
}

const useGroupInitiateTemp = () => {
  const { token } = useContext(authContext)
  const { id } = useParams<{ id: string }>()
  const { data, isLoading, error } = useQuery({
    queryKey: ['group-initiate-temp', id],
    queryFn: () => initiateTemp({ token: token!, id }),
    cacheTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    enabled: !!id,
  })

  return { data: data as { temp_update_id: number }, isLoading, error }
}

export default useGroupInitiateTemp
